import React from 'react';
import { useSelector } from 'react-redux';
import { Card, Flex, Select } from 'antd';
import ReactApexChart from 'react-apexcharts';
const VisitsSource = ({ t, data, type }) => {
  const { darkMode } = useSelector((state) => state.user);
  const seriesChart = data?.map((item) => item.qty) || [];
  const optionsChart = {
    chart: {
      type: 'donut',
    },
    stroke: {
      show: true,
    },
    // title: {
    //   text: t.TopProduct_Type,
    // },
    legend: {
      position: 'bottom',
    },
    labels: data?.map((item) => item.item_name) || [],
    // colors: ['#687cfe', '#4dd4b7', '#d65147', '#1AA1D1', '#687cfe'],
    colors: ['#0b9640', '#4dd4b7', '#d65147', '#1AA1D1', '#687cfe'],
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
  };
  return (
    <Card
      style={{ width: '100%', height: '100%' }}
      title={
        <Flex justify="space-between" align="center">
          <h3
            style={{
              fontSize: '16px',
              margin: '0 0 7px 0',
              fontWeight: 600,
              color: '#495057',
            }}
          >
            {type === 'sold' ? t.TopItemSold : t.TopItemPurchased}
          </h3>
        </Flex>
      }
    >
      <div
        className={
          darkMode
            ? 'dark-chart fex items-center justify-center'
            : 'fex items-center justify-center'
        }
      >
        <div id="chart">
          <ReactApexChart
            options={optionsChart}
            series={seriesChart}
            type="donut"
            // width={300}
            height={310}
          />
        </div>
        <div id="html-dist"></div>
      </div>
    </Card>
  );
};

export default VisitsSource;
